<style>

h3{
  text-align: center;
}

.space{
  margin: 20px;
}

.item{
  display: grid;
  grid-template-columns: 40px auto;
  color: white;
  margin: 10px 40px 0 40px;
  padding: 10px 0;
}
.check{
  grid-column: 1;
  text-align: center;
}
.text{
  grid-column: 2;
}

button.show-all{
  border: none;
  background-color: rgba(255,255,255,0.5);
  color: black;
  margin: 20px 0 0 80px;
  width: auto;
  font-size: 20px;
}
button.show-all:hover{
  border: none;
  background-color: rgba(255,255,255,0.8);
  color: black;
}

.gender{
  background-color: rgba(255,255,255,0.5);
  color: black;
}

</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}

<h3>What is your gender identity?</h3>
  
{#each genders as item}
  {#if showAllHelper(item, showAll)}
    <div class="item { gender == item.i ? 'gender' : '' }" on:click="{ () => {gender = item.i; check() } }">
      <div class="check">
        
        {#if gender == item.i}
          <i class="icon-check"></i>
        {/if}
        
      </div>
      <div class="text">{item.t}</div>
    </div>
  {/if}
{/each}

{#if !showAll}
  <button class="show-all" on:click="{ () => {showAll = true; dispatch('showAll') } }">Show All Identities</button>
{/if}


{/if}

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "../../interfaces/Auth.svelte";
let auth;

import Profile from "../../interfaces/Profile.svelte";
let profile;

import Genders from "../../helpers/Genders.js";
const genders = Genders.gender;

import Validate from "../../helpers/Validate.js";
import Normalize from "../../helpers/Normalize.js";

export let show = false;
export let me = null;

let showAll = false;
let gender = -1;


import { onMount } from "svelte";
onMount(async () => {
  set();
});


$:{
  if (me) set();
}


function set() {
  gender = me.gender;
}


function showAllHelper(item) {
  if (showAll == false && item.d == true) {
    return true;
  } else if (showAll == true) {
    return true;
  }
  
  return false;
}


function check() {
  try {
    if (gender == -1) throw "no gender selected";
  } catch (e) {
    console.log("error:", e);
  }
}


export const save = async () => {
  if (gender != me.gender) {
    me.gender = gender;
    profile.updateMe( { updateShare: true } );
  }
}


</script>